import React from "react";
import { useSelector } from "react-redux";
import { TypeOptions } from "./TypeOptions";
import { formatTime, isInteger, renderContentWithTrackedLinks } from "../../../utils/format";

const JobInformationTab = ({jobInfomation}: any) => {
  const currentUser = useSelector((state: any) => state.currentUser);
  const {company} = currentUser.staffInfo

  const {
    allowancesOptions,
    holidayAndVacationsRadioOptions,
    insuranceBenefitsOptions,
    maternityLeaveOptions,
    measuresAgainstPassiveSmoking,
    increaseForOverTimeOptions,
  } = TypeOptions();

  insuranceBenefitsOptions.forEach((item: any) => {
    const field = item.name;
    item.value = jobInfomation[field];   
  });
  const insuranceBenefitText = insuranceBenefitsOptions.filter(item => item.value === true).map(item => item.label).join(', ');

  allowancesOptions.forEach((item: any) => {
    const field = item.name;
    item.value = jobInfomation[field];   
  });
  const allowancesOptionsText = allowancesOptions.filter(item => item.value === true).map(item => item.label).join(', ');

  increaseForOverTimeOptions.forEach((item: any) => {
    const field = item.name;
    item.value = jobInfomation[field];   
  });
  const increaseForOverTimeOptionsText = increaseForOverTimeOptions.filter(item => item.value === true).map(item => item.label).join(', ');
  
  const jobInfo = {
    ...jobInfomation,
    jobType1: jobInfomation.occupation_1 ? jobInfomation.occupation_1?.name : jobInfomation.jobType1?.name,
    jobType2: jobInfomation.occupation_2?.name,
    jobType3: jobInfomation.occupation_3?.name,
    industry1: jobInfomation.industry_1?.name,
    industry2: jobInfomation.industry_2?.name,
    industry3: jobInfomation.industry_3?.name,
    post: jobInfomation.role?.label,
    recruitQuantity: jobInfomation.persons_to_hire + "人",
    location: {
      value: jobInfomation.location_city?.label + (jobInfomation.location_village ? ` ${jobInfomation.location_village}` : '') + (jobInfomation.location_building ? ` ${jobInfomation.location_building}` : '') + (jobInfomation.location_station ? ` ${jobInfomation.location_station}` : ''),
    },
    againstSmoking: measuresAgainstPassiveSmoking.find(item => item.value === jobInfomation.void_smoking_policy)?.label,
    monthly: `${jobInfomation.monthly_salary_min ? `${new Intl.NumberFormat().format(jobInfomation.monthly_salary_min)} 万円` : 'ー'}` + " 〜 " + `${jobInfomation.monthly_salary_max ? `${new Intl.NumberFormat().format(jobInfomation.monthly_salary_max)} 万円` : 'ー'}`,
    bonus: jobInfomation.bonuses_per_year ? "年" + jobInfomation.bonuses_per_year + "回" : "ー",
    payType: jobInfomation.salary_payment_method?.label,
    salaryIncrease: jobInfomation.has_salary_increment === 'True' ? "あり" : "なし",
    insuranceBenefit: { value: insuranceBenefitText, note: jobInfomation.insurance_note },
    variousAllowances: { value: allowancesOptionsText, note: jobInfomation.bonus_note },
    employmentStatus: jobInfomation.type?.label,
    workingStyle: jobInfomation.working_style?.label,
    workingHour: formatTime(jobInfomation.working_hour_from, "HH:mm") + " ～ " + formatTime(jobInfomation.working_hour_to, "HH:mm"),
    breakTime: isInteger(jobInfomation.break_time) ? jobInfomation.break_time + "時間" : jobInfomation.break_time,
    avgOTHours: jobInfomation.monthly_average_ot_hours != null &&
                jobInfomation.monthly_average_ot_hours !== ""
      ? `月${jobInfomation.monthly_average_ot_hours}時間`
      : 'ー',
    fixedOTPay: { value: jobInfomation.fixed_OT_payment === 'True' ? "あり\n" +  increaseForOverTimeOptionsText: "なし", note: jobInfomation.fixed_OT_payment_note },
    holidayVacation: { value: holidayAndVacationsRadioOptions.find(item => item.value === jobInfomation.days_off_pattern)?.label, note: jobInfomation.working_off_days_note },
    hasMaternityLeave: jobInfomation.has_maternity_leave ? maternityLeaveOptions.find(item => item.name === "has_maternity_leave")?.label : "",
    hasMaternityLeaveTracking: jobInfomation.has_maternity_leave_tracking ? maternityLeaveOptions.find(item => item.name === "has_maternity_leave_tracking")?.label : "",
    annualHoliday: jobInfomation.annual_working_off_day ? `${jobInfomation.annual_working_off_day} 日` : "ー",
    trialPeriod:  jobInfomation.probation_duration === "True" ? jobInfomation.probation_months + "ケ月" : "なし",
  }

  return (
    <div>
      <h5 className="text-sm font-bold lg:font-normal lg:text-2xl lg:leading-9 alu-text-base-2 mb-2 lg:mb-4">
        求人詳細
      </h5>
      <div>
        <div className="border-b border-[#E0E0E0] pb-3">
          <div className="py-3 flex">
            <span className="w-6 mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <mask
                  id="mask0_13734_7038"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                >
                  <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_13734_7038)">
                  <path
                    d="M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V8C2 7.45 2.19583 6.97917 2.5875 6.5875C2.97917 6.19583 3.45 6 4 6H8V4C8 3.45 8.19583 2.97917 8.5875 2.5875C8.97917 2.19583 9.45 2 10 2H14C14.55 2 15.0208 2.19583 15.4125 2.5875C15.8042 2.97917 16 3.45 16 4V6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM10 6H14V4H10V6Z"
                    fill="#808080"
                  />
                </g>
              </svg>
            </span>
            <p className="min-w-[150px] text-base alu-text-base-2">職種</p>
            <p className="flex-1 text-base alu-text-base-2">{`${jobInfo.jobType1 ? jobInfo.jobType1 : 'ー'} > ${jobInfo.jobType2 ? jobInfo.jobType2 : 'ー'} > ${jobInfo.jobType3 ? jobInfo.jobType3 : 'ー'}`}</p>
          </div>
          <div className="py-3 flex text-base alu-text-base-2">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">業種</p>
            <p className="flex-1">{`${jobInfo.industry1 ? jobInfo.industry1 : 'ー'} > ${jobInfo.industry2 ? jobInfo.industry2 : 'ー'} > ${jobInfo.industry3 ? jobInfo.industry3 : 'ー'}`}</p>
          </div>
          <div className="py-3 flex text-base alu-text-base-2">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">役職</p>
            <p className="flex-1">{jobInfo.post || 'ー'}</p>
          </div>
          <div className="py-3 flex text-base alu-text-base-2">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">採用人数</p>
            <p className="flex-1">{jobInfo.recruitQuantity}</p>
          </div>
        </div>

        <div className="border-b border-[#E0E0E0] py-3">
          <div className="py-3 flex">
            <span className="w-6 mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <mask
                  id="mask0_13734_3844"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                >
                  <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_13734_3844)">
                  <path
                    d="M3 21V7H7V3H17V11H21V21H13V17H11V21H3ZM5 19H7V17H5V19ZM5 15H7V13H5V15ZM5 11H7V9H5V11ZM9 15H11V13H9V15ZM9 11H11V9H9V11ZM9 7H11V5H9V7ZM13 15H15V13H13V15ZM13 11H15V9H13V11ZM13 7H15V5H13V7ZM17 19H19V17H17V19ZM17 15H19V13H17V15Z"
                    fill="#808080"
                  />
                </g>
              </svg>
            </span>
            <p className="min-w-[150px] text-base alu-text-base-2">勤務地詳細</p>
            <div className="flex-1 whitespace-pre-wrap break-all text-base alu-text-base-2">
              <p className="flex-1">{jobInfo.location.value}</p>
            </div>
          </div>
          <div className="py-3 flex text-base alu-text-base-2 whitespace-pre-wrap break-all">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">勤務地変更の範囲</p>
            <p className="flex-1">{renderContentWithTrackedLinks(jobInfo.location_note || 'ー')}</p>
          </div>
          <div className="py-3 flex text-base alu-text-base-2">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">受動喫煙対策</p>
            <p className="flex-1">{jobInfo.againstSmoking}</p>
          </div>
        </div>

        <div className="border-b border-[#E0E0E0] py-3">
          <div className="py-3 flex">
            <span className="w-6 mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <mask
                  id="mask0_13734_4645"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                >
                  <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_13734_4645)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.2857 16V18.8571H12.7143V16H16.2857V14.5714H12.7143V13.1429H16.2857V11.7143H13.375L17 6H15.3036L12 11.2143L8.69643 6H7L10.625 11.7143H7.71429V13.1429H11.2857V14.5714H7.71429V16H11.2857Z"
                    fill="#808080"
                  />
                </g>
              </svg>
            </span>
            <p className="min-w-[150px] text-base alu-text-base-2">給与</p>
            <p className="flex-1 text-base alu-text-base-2">{jobInfo.salary || 'ー'}</p>
          </div>
          <div className="py-3 flex text-base alu-text-base-2">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">月額</p>
            <p className="flex-1">{jobInfo.monthly || 'ー'}</p>
          </div>
          {jobInfo.bonus && (
          <div className="py-3 flex text-base alu-text-base-2">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">賞与</p>
            <p className="flex-1">{jobInfo.bonus}</p>
          </div>
          )}
          <div className="py-3 flex text-base alu-text-base-2">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">給与形態</p>
            <p className="flex-1">{jobInfo.payType}</p>
          </div>
          <div className="py-3 flex text-base alu-text-base-2">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">昇給</p>
            <p className="flex-1">{jobInfo.salaryIncrease}</p>
          </div>
          {jobInfo.wage_note && (
          <div className="py-3 flex text-base alu-text-base-2 whitespace-pre-wrap break-all">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">賃金備考</p>
            <p className="flex-1">{renderContentWithTrackedLinks(jobInfo.wage_note || 'ー')}</p>
          </div>
          )}
          <div className="py-3 flex text-base alu-text-base-2 whitespace-pre-wrap break-all">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">保険待遇</p>
            <div className="flex-1">
              <p className="flex-1">{jobInfo.insuranceBenefit.value || "ー"}</p>
              {jobInfo.insuranceBenefit.note && (<p className="flex-1">{renderContentWithTrackedLinks(jobInfo.insuranceBenefit.note)}</p>)}
            </div>
          </div>
          <div className="py-3 flex text-base alu-text-base-2 whitespace-pre-wrap break-all">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">諸手当</p>
            <div className="flex-1">
              <p className="flex-1">{jobInfo.variousAllowances.value || 'ー'}</p>
              {jobInfo.variousAllowances.note && (<p className="flex-1">{renderContentWithTrackedLinks(jobInfo.variousAllowances.note)}</p>)}
            </div>
          </div>
          <div className="py-3 flex text-base alu-text-base-2 whitespace-pre-wrap break-all">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">雇用形態</p>
            <div className="flex-1">
              <p className="flex-1">{jobInfo.employmentStatus}</p>
              {jobInfo.type_note && (<p className="flex-1">{renderContentWithTrackedLinks(jobInfo.type_note)}</p>)}
            </div>
          </div>
          <div className="py-3 flex text-base alu-text-base-2">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">勤務形態</p>
            <p className="flex-1">{jobInfo.workingStyle || 'ー'}</p>
          </div>
        </div>

        <div className="border-b border-[#E0E0E0] py-3">
          <div className="py-3 flex">
            <span className="w-6 mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <mask
                  id="mask0_13734_17237"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                >
                  <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_13734_17237)">
                  <path
                    d="M12 18C13.6667 18 15.0833 17.4167 16.25 16.25C17.4167 15.0833 18 13.6667 18 12C18 10.3333 17.4167 8.91667 16.25 7.75C15.0833 6.58333 13.6667 6 12 6V12L7.75 16.25C8.33333 16.8 8.9875 17.2292 9.7125 17.5375C10.4375 17.8458 11.2 18 12 18ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                    fill="#808080"
                  />
                </g>
              </svg>
            </span>
            <p className="min-w-[150px] text-base alu-text-base-2">勤務時間</p>
            <p className="flex-1 text-base alu-text-base-2">{jobInfo.workingHour}</p>
          </div>
          <div className="py-3 flex text-base alu-text-base-2 whitespace-pre-wrap break-all">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">休憩時間</p>
            <p className="flex-1">{renderContentWithTrackedLinks(jobInfo.breakTime)}</p>
          </div>
          <div className="py-3 flex text-base alu-text-base-2">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">平均残業時間</p>
            <p className="flex-1">{jobInfo.avgOTHours}</p>
          </div>
          <div className="py-3 flex text-base alu-text-base-2 whitespace-pre-wrap break-all">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">固定残業代</p>
            <div className="flex-1">
              <p className="flex-1">{jobInfo.fixedOTPay.value}</p>
              <p className="flex-1">{renderContentWithTrackedLinks(jobInfo.fixedOTPay.note)}</p>
            </div>
          </div>
          <div className="py-3 flex text-base alu-text-base-2 whitespace-pre-wrap break-all">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">休日休暇</p>
            <div className="flex-1">
              <p className="flex-1">{jobInfo.holidayVacation.value}</p>
              {jobInfo.hasMaternityLeave && (<p className="flex-1">{jobInfo.hasMaternityLeave}</p>)}
              {jobInfo.hasMaternityLeaveTracking && (<p className="flex-1">{jobInfo.hasMaternityLeaveTracking}</p>)}
              {jobInfo.holidayVacation.note && (<p className="flex-1">{renderContentWithTrackedLinks(jobInfo.holidayVacation.note)}</p>)}
            </div>
          </div>
          <div className="py-3 flex text-base alu-text-base-2">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">年間休日</p>
            <p className="flex-1">{jobInfo.annualHoliday}</p>
          </div>
        </div>

        <div className="py-3">
          <div className="py-3 flex text-base alu-text-base-2 whitespace-pre-wrap break-all">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">試用期間</p>
            <p className="flex-1">{jobInfo.trialPeriod}</p>
          </div>
          <div className="py-3 flex text-base alu-text-base-2 whitespace-pre-wrap break-all">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">選考の流れ</p>
            <p className="flex-1">{renderContentWithTrackedLinks(jobInfo.selection_process)}</p>
          </div>
          <div className="py-3 flex text-base alu-text-base-2 whitespace-pre-wrap break-all">
            <span className="w-6 mr-2"></span>
            <p className="min-w-[150px]">企業情報</p>
            <p className="flex-1">{company.description ? renderContentWithTrackedLinks(company.description) : company.name}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobInformationTab;